document.addEventListener('DOMContentLoaded', function() {
    const filterButton = document.querySelector('.shop-filter__btn');
    const filterInner = document.querySelector('.shop-filter__inner');
    const toggleIcon = document.querySelector('.search-filter-label__toggle-icon');
    const controlSubmitButton = document.querySelector('.search-filter-style--id-1.search-filter-style--control-submit');
    const resetButton = document.querySelector('.shop-filter__reset button');

    const searchFilterQuery = document.querySelector('.myf-search-filter-query');

    function toggleFilter() {        
        filterInner.classList.toggle('shop-filter__inner--active');
        toggleIcon.classList.toggle('search-filter-label__toggle-icon--down');
        toggleIcon.classList.toggle('search-filter-label__toggle-icon--up');
    }

    [filterButton, controlSubmitButton, resetButton].forEach(button => {
        if (button && filterInner) {
            button.addEventListener('click', function() {
                toggleFilter();
            });
        }
    });

    // Mise à jour pour aligner les 2 derniers éléments d'une ligne en grid dans le listing produit. 
    // Décalage de 2 éléments à cause de la pub en en-tete à coté des produits
    function updatePaginationClass() {
        const navigationElement = document.querySelector('.myf-pagination');

        if (navigationElement && searchFilterQuery) {
            searchFilterQuery.classList.add('has-pagination');
        } else {
            if (searchFilterQuery) {
                searchFilterQuery.classList.remove('has-pagination');
            }
        }
    }

    updatePaginationClass();

    if (searchFilterQuery) {
        const queryId = [1, 2, 3].find(id => window.searchAndFilter.frontend.queries.get(id));
        const query = window.searchAndFilter.frontend.queries.get(queryId);

        if (query) {
            // Only hook in to the update if dynamic update is enabled for the query.
            if (query.getAttribute('resultsDynamicUpdate') === 'yes') {
                // Listen for the update to the results.
                query.on('get-results/finish', function (queryObject) {
                    // console.log("pagination" + navigationElement);
                    updatePaginationClass();
                });
            }
        }
    }
});